"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const Switch_1 = tslib_1.__importDefault(require("@mui/material/Switch"));
const use_context_selector_1 = require("use-context-selector");
const Form_1 = require("../Form");
const Switch = React.forwardRef((_a, ref) => {
    var { name, onChange } = _a, props = tslib_1.__rest(_a, ["name", "onChange"]);
    const isSubmitting = (0, use_context_selector_1.useContextSelector)(Form_1.FormFieldsContext, context => context === null || context === void 0 ? void 0 : context.isSubmitting);
    const formValue = (0, use_context_selector_1.useContextSelector)(Form_1.FormFieldsContext, context => context === null || context === void 0 ? void 0 : context.getFieldValue(name));
    const setFieldValue = (0, use_context_selector_1.useContextSelector)(Form_1.FormFieldsContext, context => context === null || context === void 0 ? void 0 : context.setFieldValue);
    if (!name && setFieldValue) {
        throw new Error('@eduzz/houston-ui: to use form prop you need provide a name for the field');
    }
    const handleChange = React.useCallback((e, checked) => {
        setFieldValue && setFieldValue(name, checked);
    }, [setFieldValue, name]);
    return ((0, jsx_runtime_1.jsx)(Switch_1.default, Object.assign({ disabled: isSubmitting || props.disabled, name: name, inputRef: ref, onChange: onChange || handleChange, className: props.className, color: 'primary', checked: formValue !== null && formValue !== void 0 ? formValue : props.checked }, props)));
});
exports.default = React.memo(Switch);
